export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!

export const WIN_MESSAGES = [
  'Lieliski!',
  'Izcili!',
  'Brīnišķīgi!',
  'Ļoti labi!',
  'Teicami!',
]
export const GAME_COPIED_MESSAGE = 'Spēles rezultāts iekopēts starpliktuvē'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Par maz burtu'
export const WORD_NOT_FOUND_MESSAGE = 'Vārds netika atrasts'
export const HARD_MODE_ALERT_MESSAGE =
  'Grūto režīmu var ieslēgt tikai pirms spēles uzsākšanas'
export const HARD_MODE_DESCRIPTION =
  'Visi atklātie mājieni obligāti jāizmanto turpmākajos gājienos'
export const HIGH_CONTRAST_MODE_DESCRIPTION =
  'Speciāls vizuālais režīms, kurā informācija attēlota augsta kontrasta skatā'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `Šodienas vārds bija: ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `Minējuma ${
    ['pirmajam', 'otrajam', 'trešajam', 'ceturtajam', 'piektajam'][position]
  } burtam jābūt "${guess}"`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `Minējumam jāsatur burts "${letter}"`
export const ENTER_TEXT = 'Enter'
export const DELETE_TEXT = 'Delete'
export const STATISTICS_TITLE = 'Statistika'
export const GUESS_DISTRIBUTION_TEXT = 'Minējumu sadalījums'
export const NEW_WORD_TEXT = 'Jauns vārds pēc'
export const SHARE_TEXT = 'Dalīties'
export const SHARE_FAILURE_TEXT = 'Notika kļūda, cenšoties kopīgot rezultātus!'
export const MIGRATE_BUTTON_TEXT = 'Migrēt'
export const MIGRATE_DESCRIPTION_TEXT =
  'Klikšķini šeit, lai pārvietotu savu statistiku uz jaunu vai citu ierīci.'
export const TOTAL_TRIES_TEXT = 'Mēģinājumi'
export const SUCCESS_RATE_TEXT = 'Uzminēti'
export const CURRENT_STREAK_TEXT = 'Šobrīd secīgi uzminēti'
export const BEST_STREAK_TEXT = 'Visvairāk secīgi uzminēti'
export const DISCOURAGE_INAPP_BROWSER_TEXT =
  'Izskatās, ka izmanto "in-app" pārlūkprogrammu. Lietojot to, var rasties problēmas ar rezultātu kopīgošanu vai saglabāšanu. Iesaku izmantot ierīces noklusējuma pārlūkprogrammu.'

export const DATEPICKER_TITLE = 'Ceļo laikā!'
export const DATEPICKER_CHOOSE_TEXT = 'Doties uz:'
export const DATEPICKER_TODAY_TEXT = 'Atgriezties tagadnē'
export const ARCHIVE_GAMEDATE_TEXT = 'Spēles datums'
